import { ApiType } from "@gymflow/common";
import { EventOccurrenceDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import merge from "lodash/merge";

import { eventOccurrenceQueryKeys } from "./eventOccurrenceQueryKeys";
import { eventOccurrenceToZonedTime } from "./eventOccurrenceToZonedTime";

export async function eventOccurrenceQueryFn({
  eventId,
  api,
}: {
  eventId: number;
  api: ApiType;
}) {
  return (await api.eventApi.findById(eventId)).data;
}

export function useEventOccurrence(
  {
    api,
    eventId,
    timezone,
  }: {
    api: ApiType;
    eventId: number | null;
    timezone: string;
  },
  opts?: Omit<UseQueryOptions<EventOccurrenceDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: eventOccurrenceQueryKeys.details(eventId),
    queryFn: () => {
      return eventOccurrenceQueryFn({ api, eventId: eventId as number });
    },
    enabled: !!eventId,
    select: (data) => {
      if (!data) {
        return null;
      }
      return merge(
        {},
        data,
        eventOccurrenceToZonedTime(data, timezone),
      ) as EventOccurrenceDTO;
    },
    ...opts,
  });
}
